export const CURRENT_TRANSFORMER_RATIOS: Options<string> = [
  { value: '1:1', label: '1:1' }, // default when "Current transformer" off
  { value: '50:5', label: '50:5' },
  { value: '63:5', label: '63:5' },
  { value: '75:5', label: '75:5' },
  { value: '80:5', label: '80:5' },
  { value: '100:5', label: '100:5' },
  { value: '125:5', label: '125:5' },
  { value: '150:5', label: '150:5' },
  { value: '160:5', label: '160:5' },
  { value: '200:5', label: '200:5' },
  { value: '250:5', label: '250:5' },
  { value: '300:5', label: '300:5' },
  { value: '400:5', label: '400:5' }, // default when "Current transformer" on
  { value: '600:5', label: '600:5' },
  { value: '800:5', label: '800:5' },
  { value: '1000:5', label: '1000:5' },
  { value: '1250:5', label: '1250:5' },
  { value: '1500:5', label: '1500:5' },
  { value: '1600:5', label: '1600:5' },
  { value: '2000:5', label: '2000:5' },
  { value: '2500:5', label: '2500:5' },
  { value: '3000:5', label: '3000:5' },
]
